import { useMemo, useState } from "react";
import styles from "../detalhe.styles.module.css";
import FiltroContasMultiSelect from "./FiltroContasMultiSelect";
import FiltroBaseLegalMultiSelect from "./FiltroBaseLegalMultiSelect";
import { opcoesBaseLegal } from "../utils/baseLegalMultiSelect.util";

export default function FiltrosSumarizacao({
  filtros,
  onChange,
  contasDisponiveis = [],
  basesLegais = [],
  onLimpar,
  projetosAprovados = [],
  projetoSelecionado = "",
  onProjetoChange,
}) {
  const [expandido, setExpandido] = useState(true);
  const set = (campo, valor) => onChange({ ...filtros, [campo]: valor });

  const contasSel = filtros.contasSelecionadas || [];
  const baseLegalSel = filtros.baseLegalSelecionadas || [];

  const opcoesConta = useMemo(
    () =>
      [...contasDisponiveis].sort((a, b) =>
        String(a.label).localeCompare(String(b.label), "pt-BR")
      ),
    [contasDisponiveis]
  );

  const opcoesBaseLegalLista = useMemo(() => opcoesBaseLegal(basesLegais), [basesLegais]);

  return (
    <div className={`${styles.filtersSection} ${!expandido ? styles.filtersSectionCollapsed : ""}`}>
      <button
        type="button"
        className={`${styles.filtersHeader} ${expandido ? styles.filtersHeaderExpanded : ""}`}
        onClick={() => setExpandido((v) => !v)}
        aria-expanded={expandido}
        aria-controls="filtros-sumarizacao-body"
      >
        <span className={styles.filtersTitle}>Filtros</span>
        <span
          className={`${styles.filtersToggleIcon} ${expandido ? styles.filtersToggleIconOpen : ""}`}
          aria-hidden
        >
          ▼
        </span>
      </button>

      {expandido && (
        <div id="filtros-sumarizacao-body" className={styles.filtersBody}>
          <div className={styles.filtersRow}>
            <div className={styles.filterGroup}>
              <span className={styles.filterLabel}>Conta contábil</span>
              <FiltroContasMultiSelect
                opcoes={opcoesConta}
                selecionadas={contasSel}
                onChange={(lista) => set("contasSelecionadas", lista)}
              />
            </div>

            <div className={styles.filterGroup}>
              <span className={styles.filterLabel}>Competência</span>
              <div className={styles.filterTwin}>
                <input
                  className={styles.filterInput}
                  type="month"
                  value={filtros.competenciaInicio || ""}
                  onChange={(e) => set("competenciaInicio", e.target.value)}
                  aria-label="Competência início"
                />
                <span className={styles.filterTwinSep}>até</span>
                <input
                  className={styles.filterInput}
                  type="month"
                  value={filtros.competenciaFim || ""}
                  onChange={(e) => set("competenciaFim", e.target.value)}
                  aria-label="Competência fim"
                />
              </div>
            </div>

            <div className={styles.filterGroup}>
              <span className={styles.filterLabel}>Base legal</span>
              <FiltroBaseLegalMultiSelect
                opcoes={opcoesBaseLegalLista}
                selecionadas={baseLegalSel}
                onChange={(lista) => set("baseLegalSelecionadas", lista)}
              />
            </div>

            <div className={styles.filterGroup}>
              <span className={styles.filterLabel}>Base de cálculo (R$)</span>
              <div className={styles.filterTwin}>
                <input
                  className={styles.filterInput}
                  type="number"
                  placeholder="Mín."
                  value={filtros.baseMin ?? ""}
                  onChange={(e) => set("baseMin", e.target.value)}
                />
                <span className={styles.filterTwinSep}>até</span>
                <input
                  className={styles.filterInput}
                  type="number"
                  placeholder="Máx."
                  value={filtros.baseMax ?? ""}
                  onChange={(e) => set("baseMax", e.target.value)}
                />
              </div>
            </div>

            <div className={styles.filterGroup}>
              <span className={styles.filterLabel}>Valor PIS (R$)</span>
              <div className={styles.filterTwin}>
                <input
                  className={styles.filterInput}
                  type="number"
                  placeholder="Mín."
                  value={filtros.pisMin ?? ""}
                  onChange={(e) => set("pisMin", e.target.value)}
                />
                <span className={styles.filterTwinSep}>até</span>
                <input
                  className={styles.filterInput}
                  type="number"
                  placeholder="Máx."
                  value={filtros.pisMax ?? ""}
                  onChange={(e) => set("pisMax", e.target.value)}
                />
              </div>
            </div>

            <div className={styles.filterGroup}>
              <span className={styles.filterLabel}>Valor COFINS (R$)</span>
              <div className={styles.filterTwin}>
                <input
                  className={styles.filterInput}
                  type="number"
                  placeholder="Mín."
                  value={filtros.cofinsMin ?? ""}
                  onChange={(e) => set("cofinsMin", e.target.value)}
                />
                <span className={styles.filterTwinSep}>até</span>
                <input
                  className={styles.filterInput}
                  type="number"
                  placeholder="Máx."
                  value={filtros.cofinsMax ?? ""}
                  onChange={(e) => set("cofinsMax", e.target.value)}
                />
              </div>
            </div>

            {/* TXM-558 — itens utilizados por projetos aprovados ficam fora do resultado padrão;
                os de um projeto só aparecem escolhendo-o aqui (modo consulta). */}
            {projetosAprovados.length > 0 && (
              <div className={styles.filterGroup}>
                <label className={styles.filterLabel} htmlFor="filtro-projeto">
                  Projeto
                </label>
                <select
                  id="filtro-projeto"
                  className={styles.filterInput}
                  value={projetoSelecionado === null ? "" : String(projetoSelecionado)}
                  onChange={(e) =>
                    onProjetoChange?.(e.target.value === "" ? null : Number(e.target.value))
                  }
                >
                  <option value="">Itens disponíveis</option>
                  {projetosAprovados.map((projeto) => (
                    <option key={projeto.idProjeto} value={String(projeto.idProjeto)}>
                      {projeto.codigo}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className={styles.filterGroup}>
              <span className={styles.filterLabel}>&nbsp;</span>
              <button type="button" className={styles.btnPage} onClick={onLimpar}>
                Limpar filtros
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
